'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _userUtil = require('../../user/userUtil');

require('./UserAvatar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO 944 - Add back in when user image design is completed
// import ImageAvatar from './ImageAvatar';

// Util
// Lib
var GuestAvatar = function GuestAvatar() {
    return _react2.default.createElement(
        'span',
        { className: 'guest' },
        _react2.default.createElement(_Icon2.default, { name: 'user-guest' })
    );
};

// Styles


// Components


var getAvatar = function getAvatar(user, size) {
    if (!user || user.get('isGuest')) return _react2.default.createElement(GuestAvatar, null);

    // TODO 944 - Add back in when user image design is completed
    // if (user.get('image')) return <ImageAvatar user={user} size={size} />;

    if (!user.getIn(['name', 'givenName'])) return _react2.default.createElement(GuestAvatar, null);

    return _react2.default.createElement(
        'span',
        { className: 'initals' },
        (0, _userUtil.getInitials)(user)
    );
};

var UserAvatar = function UserAvatar(_ref) {
    var user = _ref.user,
        pulse = _ref.pulse,
        active = _ref.active,
        filter = _ref.filter,
        size = _ref.size;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('UserAvatar', size, { pulse: pulse, active: active, filter: filter }) },
        getAvatar(user, size),
        _react2.default.createElement('div', { className: 'border' })
    );
};

UserAvatar.propTypes = {
    user: _propTypes2.default.object.isRequired,
    pulse: _propTypes2.default.bool,
    active: _propTypes2.default.bool,
    filter: _propTypes2.default.bool,
    size: _propTypes2.default.string
};

exports.default = UserAvatar;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/userAvatar/UserAvatar.js
// module id = 199
// module chunks = 0